import { MODAL_SIZES, ModalFooter } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';
import { UnlinkButton } from './UnlinkButton';
import { InsertLinkButton } from './InsertLinkButton';

export const Footer = () => {
  const { hideModal } = useModalContext();
  return (
    <ModalFooter size={MODAL_SIZES.MEDIUM} onClose={hideModal}>
      <UnlinkButton />
      <InsertLinkButton />
    </ModalFooter>
  );
};
